import { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import type { SelectFieldProps } from "./FormFields.interface";
import api from "../../api/axios";
import "./SelectField.css";

interface SelectOption {
  value: number;
  label: string;
}

interface ApiOption {
  id: number;
  value: string;
}

export default function SelectField({
  label,
  field,
  value,
  onChange,
  placeholder = "Выберите...",
  invalid,
  clearable = false,
}: SelectFieldProps) {
  const [options, setOptions] = useState<ApiOption[]>();

  const getSelectionFieldOptions = async () => {
    try {
      const { data } = await api.get<ApiOption[]>(
        "/api-gateway/selection-field-options",
        {
          params: {
            field,
          },
        },
      );
      if (!data) {
        throw new Error("Отсутствуют данные");
      }
      setOptions(data);
    } catch (error) {
      console.log(
        `Не удалось получить значения для выпадающих списков: ${error}`,
      );
      return [];
    }
  };

  useEffect(() => {
    getSelectionFieldOptions();
  }, []);

  const selectOptions = useMemo<SelectOption[]>(
    () =>
      options?.map((opt) => ({
        value: opt.id,
        label: opt.value,
      })) ?? [],
    [options],
  );

  const selectedValue = useMemo(
    () => selectOptions.find((opt) => opt.value === value?.id) ?? null,
    [selectOptions, value],
  );

  const handleChange = (selected: SelectOption | null) => {
    onChange(selected ? { id: selected.value, value: selected.label } : null);
  };

  return (
    <div className={`form-field ${invalid ? "invalid" : ""}`}>
      <label>{label}</label>
      <Select<SelectOption, false>
        className="select-field-container"
        classNamePrefix="select-field"
        options={selectOptions}
        value={selectedValue}
        onChange={handleChange}
        placeholder={placeholder}
        noOptionsMessage={() => "Нет вариантов"}
        isClearable={clearable}
      />
    </div>
  );
}
